"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsInRRule = exports.isInRRule = void 0;
const get_1 = __importDefault(require("lodash/get"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const isString_1 = __importDefault(require("lodash/isString"));
const merge_1 = __importDefault(require("lodash/merge"));
const rrule_1 = require("rrule");
const native_1 = require("../../native");
const Exists_1 = require("../common/Exists");
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
const IsRRule_1 = require("./IsRRule");
async function isInRRule(value, args, constraints) {
    var _a;
    constraints = (0, merge_1.default)({}, constraints);
    const existsResults = await (0, Exists_1.exists)(value, args, {
        isOptional: constraints === null || constraints === void 0 ? void 0 : constraints.isOptional,
        if: constraints === null || constraints === void 0 ? void 0 : constraints.if,
        allowEmptyString: false,
    });
    if (existsResults.pass === false || existsResults.skipped) {
        return existsResults;
    }
    // Get and check date values
    // Convert to date only in UTC to play nice with RRUle
    const values = [].concat(value);
    const utcDates = values.map((mapValue) => {
        const zdt = native_1.DateUtils.toZonedDateTime(mapValue, constraints.zone);
        return !(0, isNil_1.default)(zdt) ? new Date(Date.UTC(zdt.year(), zdt.monthValue() - 1, zdt.dayOfMonth())) : zdt;
    });
    if (utcDates.some((utcDate) => (0, isNil_1.default)(utcDate))) {
        return { pass: false, message: `should have valid date(s)` };
    }
    // Get and check rrule
    const rruleValue = (_a = constraints.rrule) !== null && _a !== void 0 ? _a : (0, get_1.default)(args === null || args === void 0 ? void 0 : args.object, constraints.rruleProperty);
    if ((0, isNil_1.default)(rruleValue)) {
        return { pass: true };
    }
    const isRRuleResult = await (0, IsRRule_1.isRRule)(rruleValue);
    if (!isRRuleResult.pass) {
        isRRuleResult.message = `RRule ${isRRuleResult.message}`;
        return isRRuleResult;
    }
    const rrule = convertToRRule(rruleValue);
    // Check that all date values are in rrule
    const allDateMatches = utcDates.every((utcDate) => {
        const rruleWithStartDate = new rrule_1.RRule({ ...rrule.options, dtstart: utcDate });
        const earliestRRuleDate = rruleWithStartDate.after(utcDate, true);
        const dateIncluded = utcDate.getUTCDate() === (earliestRRuleDate === null || earliestRRuleDate === void 0 ? void 0 : earliestRRuleDate.getUTCDate()) &&
            utcDate.getUTCMonth() === (earliestRRuleDate === null || earliestRRuleDate === void 0 ? void 0 : earliestRRuleDate.getUTCMonth()) &&
            utcDate.getUTCFullYear() === (earliestRRuleDate === null || earliestRRuleDate === void 0 ? void 0 : earliestRRuleDate.getUTCFullYear());
        return dateIncluded;
    });
    if (!allDateMatches) {
        return { pass: false, message: `should have date(s) that complies with the RRule` };
    }
    return { pass: true };
}
exports.isInRRule = isInRRule;
/**
 * Validates that the date complies with the given RRule
 * Works with date array as well
 */
function IsInRRule(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsInRRule",
        defaultMessage: `should have a date time that complies with the RRule`,
        options,
        constraints,
        validateFn: isInRRule,
    });
}
exports.IsInRRule = IsInRRule;
// =============================================================================
// Helpers
// =============================================================================
function convertToRRule(value) {
    if ((0, isString_1.default)(value)) {
        try {
            return rrule_1.RRule.fromString(value);
        }
        catch (e) {
            return null;
        }
    }
    return value;
}
//# sourceMappingURL=IsInRRule.js.map